"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.createI18nConfig = void 0;
var i18next_1 = __importDefault(require("i18next"));
var react_i18next_1 = require("react-i18next");
var i18next_chained_backend_1 = __importDefault(require("i18next-chained-backend"));
var i18next_http_backend_1 = __importDefault(require("i18next-http-backend"));
/**
 * Initilizes the i18n library using configuration from the source.i18nConfig key.
 * @docs https://www.i18next.com
 * @docs https://react.i18next.com/
 * @param source The source object.
 */
var createI18nConfig = function (source) {
    var _a, _b, _c, _d;
    i18next_1["default"]
        .use(i18next_chained_backend_1["default"])
        .use(react_i18next_1.initReactI18next)
        .init({
        debug: process.env.REACT_APP_DEBUG_MODE_ENABLED === 'true',
        fallbackLng: 'en',
        lng: (_b = (_a = source.i18nConfig) === null || _a === void 0 ? void 0 : _a.lng) !== null && _b !== void 0 ? _b : 'en',
        ns: ['translations'],
        lowerCaseLng: true,
        supportedLngs: (_d = (_c = source.i18nConfig) === null || _c === void 0 ? void 0 : _c.supportedLngs) !== null && _d !== void 0 ? _d : ['en'],
        backend: {
            backends: [i18next_http_backend_1["default"], i18next_http_backend_1["default"]],
            backendOptions: [
                {
                    loadPath: "https://".concat(process.env.REACT_APP_TRANSLATIONS_BUCKET, ".s3.amazonaws.com/").concat(source.sourceId, "/locales/{{lng}}/_translations.json"),
                    crossDomain: true
                },
                {
                    loadPath: "https://".concat(process.env.REACT_APP_TRANSLATIONS_BUCKET, ".s3.amazonaws.com/company/locales/{{lng}}/_translations.json"),
                    crossDomain: true
                },
            ]
        }
    });
};
exports.createI18nConfig = createI18nConfig;
